import { PromptDialog } from "components/PromptDialog";
import { FC, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store";
import { setOpen as setDialogOpen } from "store/slices/dialog.store";

type SignoutDialogProps = {
  partnerView?: boolean;
};
export const SignoutDialog: FC<SignoutDialogProps> = ({ partnerView }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { signout: open } = useAppSelector((state) => state.dialog);
  const setOpen = useCallback(
    (open: boolean) => {
      dispatch(setDialogOpen({ dialogName: "signout", open }));
    },
    [dispatch]
  );

  return (
    <PromptDialog
      aria-labelledby="alert-dialog-title"
      aria-describedby={intl.formatMessage({
        id: "logout.dataLossWarning",
      })}
      data-testid="signoutDialog"
      open={open}
      setOpen={setOpen}
      okText={intl.formatMessage({ id: "general.yes" })}
      cancelText={intl.formatMessage({ id: "general.no" })}
      onOk={() => {
        if (partnerView) {
          navigate("/login", { replace: true });
        } else {
          navigate("/logout", { replace: true });
        }
      }}
      title={<FormattedMessage id="offline.unsavedChanges" />}
      promptContent={
        <>
          <FormattedMessage id="logout.signoutDataLossWarning" />.{" "}
          <FormattedMessage id="logout.prompt" />
        </>
      }
    />
  );
};
